/* eslint-disable no-console */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KngDataTableService } from './kng-data-table.service';
import { CheckboxData, Icons, KngDataTable, NoResultData, TableData } from './definitions';
import { FieldType, KngGridPager, OrderClassList, SortOrder, SubscriptionClassList, SubscriptionType } from '../card-list/definitions';
import { PagerService } from '../card-list/kng-card-list.service';
import { DataTableConst } from './definitions/kng-data-table.enums';

@Component({
	selector: 'kng-data-table',
	templateUrl: './template/kng-data-table.component.html',
	styleUrls: ['./template/kng-data-table.component.scss']
})
export class KngDataTableComponent 
{	
	@Input() state :KngDataTable = {
		headers: [],
		checkboxRequired: false,
		checkboxState: false,
		paginationRequired: false,
		tableData: [],
		headerCheckboxdisabled: false,
		mobileSelectAllDisable: true,
		deleteRowdRequired: false
	};
	
	@Output() checkboxClickedEvent: EventEmitter<CheckboxData> = new EventEmitter<CheckboxData>();
	@Output() headerCheckboxClickedEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() stateChanged: EventEmitter<KngDataTable> = new EventEmitter<KngDataTable>();
	@Output() deleteRowClickedEvent: EventEmitter<TableData> = new EventEmitter<TableData>();

	headerSortable: string = SortOrder.asc;
	activeIndex: number = -1;
	currentPage: number = 1;
	pageLoad: boolean = false;
	pageNumber: number = 1;
	pager: KngGridPager = {
		totalPages: 1,
		currentPage: this.currentPage,
		endIndex: 0,
		endPage: 1,
		pageSize: 50,
		startIndex: 0,
		startPage: 1,
		totalItems: this.state.tableData.length
	};
	noResult: NoResultData = {
		icon: {
			iconPath: Icons.noResult,
  			altText: ''
		},
		messageBold: DataTableConst.noresult,
		message: ''
	};
	dataTableConst = DataTableConst;
	subscriptionType = SubscriptionType;
	fieldType = FieldType;
	constructor(private readonly service: KngDataTableService, private readonly pagerService: PagerService) {}
	
	handleItemCheckBoxChange(item: CheckboxData)
	{
		const computedIndex = item.itemIndex + ((this.currentPage-1) * this.pager.pageSize);
		item.itemIndex = computedIndex;
		this.checkboxClickedEvent.emit(item);
	}
	handleHeaderCheckboxChange(isChecked: boolean)
	{
		this.state.checkboxState = isChecked;
		this.headerCheckboxClickedEvent.emit(isChecked);
	}

	emitDelete(item: TableData)
	{
		this.deleteRowClickedEvent.emit(item);
	}
	setPage(e: number)
	{
		this.pager.totalPages = Math.ceil(this.state.tableData.length / this.pager.pageSize);
		this.pageLoad = true;
		setTimeout(() => 
		{
			this.pageLoad = false;
			
		}, 500);
		this.pageNumber = e;
		if (e < 1 || e > this.pager.totalPages) 
		{
			return;
		}
		else 
		{
			this.pager.currentPage = e;
		}
		this.currentPage = e;
		this.pager = this.pagerService.getPager(this.state.tableData.length, e, this.pager.pageSize);
	}

	sortColumn(sortField: string, index: number, sortOrder: string)
	{
		if(sortOrder && this.state.tableData.length > 0)
		{
			this.activeIndex = index;
			this.headerSortable = (sortOrder === SortOrder.asc) ? SortOrder.desc : SortOrder.asc;
			this.state.tableData = this.service.sortGridData(this.state.tableData, this.headerSortable, sortField);
		}
	}

	getSubscriptionStatusClass(value : string | number | boolean)
	{
		switch(value) 
		{
		case this.subscriptionType.noSubscription:
			return SubscriptionClassList.nosub;
	
		case this.subscriptionType.myinsightscompliance:
			return SubscriptionClassList.myInsightCompliance;
				
		case this.subscriptionType.myinsights:
			return OrderClassList.orderInProcess;
	
		default:
			return '';
		}
	}

	modifyTooltipContent()
	{
		const observer = new MutationObserver(()=>
		{
			const tooltip  = document.querySelector('.subscription-table-header');
			if(tooltip)
			{
				tooltip.innerHTML = tooltip.innerHTML.replace(/Invoice on/, '<b>Invoice on</b>');
				tooltip.innerHTML = tooltip.innerHTML.replace(/Renewal on/, '<br><b>Renewal on</b>');
				tooltip.innerHTML = tooltip.innerHTML.replace(/Ends on/, '<br><b>Ends on</B>');
			}
			observer.disconnect();
		});
		observer.observe(document.body, { childList: true, subtree: true } );

		setTimeout(()=> observer.disconnect(), 1000 );
	}
}
